angular.module('tf.controllers')
    .filter('capitalize', function() {
        return function(input) {
            if (input) {
                return input.charAt(0).toUpperCase() + input.slice(1);
            }
            return '';
        };
    })
    .controller('HistoryController', ['$scope', 'HttpService', 'HistoryService', '$rootScope', 'ProjectStorageService', '$stateParams', '$state', 'HeaderService',
        function ($scope, HttpService, HistoryService, $rootScope, ProjectStorageService, $stateParams, $state, HeaderService) {

            $scope.displayResults = 'table';

            HeaderService.setName("History");

            $scope.query = {
                q: $stateParams.q || '',
                from_date: $stateParams.from_date,
                to_date: $stateParams.to_date,
                page: $stateParams.page,
                page_size: $stateParams.page_size
            };

            $scope.$watch('query', function (val1, val2) {
                if (val1 === val2) { return; }
                if (val1.q !== val2.q && val1.page !== '0') { $scope.query.page = '0'; return; }
                $scope.search($scope.query);
                $state.go($state.current.name, $scope.query, { notify: false });
            }, true);

            var getHistory = function (query, uid, page, limit) {
                $scope.loader({ overlay: false });
                HistoryService.getUserHistory(query, uid, page, limit).then(function (res) {
                    $scope.history = _.map(res.history, function (item) {
                        return _.extend({}, item, { created_time: item.created_time });
                    });
                    $scope.total = res.total;
                    $scope.page = res.page;
                    $scope.limit = res.limit;
                    $scope.loader(false);
                }, function () {
                    $scope.loader(false);
                });
            };

            $scope.loadFromHistory = function (item) {
                clearStorage();
                if (item.type === 'produce') {
                    $state.go('app.project', { path: item.project.url });
                }
            };

            function clearStorage() {
                return ProjectStorageService.delete();
            }

            $scope.formatDate = function (date) {
                return moment(date).format('MMM Do YY hh:mm');
            };

            $scope.search = function (query) {
                getHistory(query);
            };

            $scope.next = function () {
                $scope.query.page++;
            };
            $scope.previous = function () {
                $scope.query.page--;
            };

            getHistory($scope.query);

        }]);